import { getAllEntradas, saveEntrada, updateEntrada, filterAll, deleteEntrada, getBalanco } from '@/services/api/entrada.js';
export const actions = {
  async getEntradasByFilter(state, filter) {
    try {
      const dataList = await filterAll(filter);
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getBalancoByEntrada(state, filter) {
    try {
      const dataList = await getBalanco(filter);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getAllEntradas(state) {
    try {
      const dataList = await getAllEntradas();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveEntrada(state, payload) {
    try {
      await saveEntrada(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro realizado',
          message: `Cadastrado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateEntrada(state, payload) {
    try {
      await updateEntrada(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async deleteEntrada(state, payload) {
    try {
      await deleteEntrada(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  
}
